import { RootSvg } from './RootSvg';
import type { RootSvgProps } from './RootSvg';

export function MuiLogotypeIcon(props: RootSvgProps) {
  return (
    <RootSvg
      viewBox="0 0 117 36"
      sx={[
        (theme) => ({
          flexShrink: 0,
          color: 'common.black',
          ...theme.applyDarkStyles({
            color: '#fff',
          }),
        }),
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
      {...props}
    >
      <path
        fill="#0079f5"
        d="M11.59 10.23.75 3.93a.5.5 0 0 0-.75.44V21.9q.01.28.25.43l4.05 2.38a.5.5 0 0 0 .75-.43V12.84a.2.2 0 0 1 .3-.17l6.25 3.58a2 2 0 0 0 2-.01l6.1-3.57a.2.2 0 0 1 .3.17v5.6a1 1 0 0 1-.48.85l-6.28 3.86a.5.5 0 0 0-.24.43v5.64q.01.28.23.43l8.23 5.2a2 2 0 0 0 2.1.02l10.46-6.2a2 2 0 0 0 .98-1.73V16.13a.5.5 0 0 0-.76-.43l-3.31 2a2 2 0 0 0-.97 1.7v5.43a.5.5 0 0 1-.25.43l-6.19 3.65a2 2 0 0 1-2.04-.01l-3.33-2a.5.5 0 0 1-.02-.84l6.02-3.97a2 2 0 0 0 .9-1.67V4.37a.5.5 0 0 0-.75-.43l-10.7 6.29a2 2 0 0 1-2.01 0"
      />
      <path
        fill="#0079f5"
        d="M35 4.86v3.42a2 2 0 0 1-.94 1.7l-3.3 2.05a.5.5 0 0 1-.76-.43V8.02a2 2 0 0 1 1-1.73l3.25-1.86a.5.5 0 0 1 .75.43"
      />
      <path
        fill="currentColor"
        d="M50.38 26V7.8h4.5l7.56 10.5-3.32-.02L66.7 7.8h4.44V26H66.2v-5.02q0-2.24.1-4.1.1-1.9.42-3.83l.52 1.61-5.64 7.28h-1.72l-5.62-7.35.58-1.54q.3 1.88.41 3.75.1 1.86.1 4.18V26zm34.88.16q-2.66 0-4.7-1.04a8 8 0 0 1-3.18-2.89 8 8 0 0 1-1.11-4.19V7.8h5.2v10.09q0 1.14.49 2 .5.85 1.35 1.33a4 4 0 0 0 1.95.46q1.14 0 2.03-.46.9-.48 1.4-1.33.52-.86.52-2V7.8h5.05v10.24a7.8 7.8 0 0 1-4.3 7.08q-2 1.04-4.7 1.04M99.67 26v-4.32h4.19v-9.56h-4.19V7.8h13.5v4.32H109v9.56h4.16V26z"
      />
    </RootSvg>
  );
}
